import React from 'react';
interface StrengthsGridProps {
  strengths: string[];
}
export function StrengthsGrid({
  strengths
}: StrengthsGridProps) {
  return <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-67">
      {strengths.map((strength, idx) => <div key={idx} className="bg-white border border-slate-200 p-3 text-center rounded text-sm font-medium text-slate-700 hover:border-blue-600 hover:text-blue-700 transition-colors cursor-default print:border-black print:text-black print:bg-transparent" data-id="element-68">
          {strength}
        </div>)}
    </div>;
}